module.exports = __webpack_public_path__ + "static/media/bg_multiport.dc7cb780.png";